module.exports = __webpack_public_path__ + "img/img_notice_pop_main_01.7bc18772.png";